export default __webpack_public_path__ + "static/media/check-mark.00a52cbe.png";